interface GetHeightFromWidthParams {
  aspectRatio?: Content.Components['AspectRatio'];
  width: number;
}

/**
 * Calculates the height of a container based on the given width and aspect ratio.
 *
 * @param params - An object containing:
 * @param params.width - The width of the container in pixels.
 * @param params.aspectRatio - The desired aspect ratio. Supported values:
 *   - `'fourByThree'` (4:3)
 *   - `'nineBySixteen'` (9:16)
 *   - `'oneByOne'` (1:1)
 *   - `'sixteenByNine'` (16:9)
 *   - `'threeByFour'` (3:4)
 *
 * @returns The calculated height in pixels based on the specified aspect ratio.
 * If an unsupported aspect ratio is provided, the function defaults to 4:3.
 */

export const getHeightFromWidth = ({
  width,
  aspectRatio = 'fourByThree',
}: GetHeightFromWidthParams): number => {
  switch (aspectRatio) {
    case 'fourByThree':
      return (3 / 4) * width;

    case 'nineBySixteen':
      return (16 / 9) * width;

    case 'oneByOne':
      return width;

    case 'sixteenByNine':
      return (9 / 16) * width;

    case 'threeByFour':
      return (4 / 3) * width;

    default:
      return (3 / 4) * width;
  }
};
